// extracted by mini-css-extract-plugin
module.exports = {"select-wrapper":"select-wrapper__39_a3","label":"label__3DuPQ","body":"body__uTn0e","select":"select__oEgOb"};